import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { FlexBox } from '../../tableItems';
import { MainButton } from '../../buttons';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  bgcolor: 'background.paper',
  borderRadius: '7px',
  boxShadow: 24,
  px: 3,
  pt: 2,
  pb: 3,
};

interface Props {
  open: boolean;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  name: string;
  deleteFunc: () => Promise<void>;
}

const DeleteFavFilter = ({
  open,
  closeModal,
  loading,
  name,
  deleteFunc,
}: Props) => {
  return (
    <Modal open={open}>
      <Box sx={style}>
        <Box justifyContent="end" display="flex">
          <IconButton onClick={() => closeModal(false)} sx={{ fontSize: 17 }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
        <Typography
          fontWeight={700}
          fontSize={17}
          textAlign="center"
          textTransform="capitalize"
        >
          Delete Favorite Filter
        </Typography>
        <Box marginTop={1}>
          <Typography fontSize={13} marginBottom={1.3} textAlign="center">
            Are you sure you want to delete{' '}
            <Typography display="inline" fontSize={13} fontWeight={600}>
              {name}
            </Typography>
            ? This change can not be undone.
          </Typography>
        </Box>
        <Box marginTop={3.5}>
          <FlexBox marginTop={3} justifyContent="center">
            <MainButton
              onClick={() => closeModal(false)}
              variant="contained"
              sx={{
                backgroundColor: '#F0F0F0',
                color: 'black',
                marginRight: 1,
                '&:hover': {
                  backgroundColor: '#F2F2F2',
                },
              }}
            >
              Cancel
            </MainButton>
            <MainButton
              variant="contained"
              onClick={() => deleteFunc()}
              loading={loading}
              sx={{ marginLeft: 1 }}
            >
              Save
            </MainButton>
          </FlexBox>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteFavFilter;
